import { useAuth } from "@/contexts/AuthContext";
import { useT } from "@/contexts/I18nContext";
import { OutstandingBanner } from "@/features/legal/OutstandingBanner";
import { OwnerChecklist } from "@/features/onboarding/OwnerChecklist";
import { TeacherWelcome } from "@/features/onboarding/TeacherWelcome";
import { TeacherHome } from "@/features/onboarding/TeacherHome";

/**
 * The landing page.
 *
 * A greeting, and — while the institution is still being set up — the list of
 * what to do next. An owner gets the checklist; a teacher gets one panel that
 * says what this place is for and where the scenes are written. The counts
 * and the recent-session list arrive with the features that produce them.
 */
export function DashboardPage() {
  const t = useT();
  const { user, hasRole } = useAuth();

  return (
    <div>
      {/* Before the greeting, because it is the only thing on this page that
          stops a lesson from happening. */}
      <OutstandingBanner />
      <h1 className="page-title">{t("dashboard.title")}</h1>
      <p className="mb-8 mt-2 text-[14px] text-ink-muted">
        {t("dashboard.welcome", { name: user?.displayName ?? "" })}
      </p>
      {hasRole(["owner"]) ? <OwnerChecklist /> : null}
      {hasRole(["teacher"]) ? <TeacherWelcome /> : null}
      {/* The page under the welcome panel. Without it, a teacher who dismissed
          the panel met a blank field every morning (live run, 2026-09-09). */}
      {hasRole(["teacher"]) && !hasRole(["owner"]) ? <TeacherHome /> : null}
    </div>
  );
}
